<template>
	<div class="checkout-layout">
	<Body class="page-checkout" />
		<ClientOnly>
			<BaseWebshopCheckout>
				<slot name="header" />

				<div class="wc-cols">
					<div class="wc-col1">
						<div class="wc-col1-cnt">
							<slot name="wcCol1" />
						</div>
					</div>
					<div class="wc-col2">
						<div class="wc-col2-cnt">
							<div class="wc-priority-order">
								<div class="wc-col-cnt priority-order-col-cnt">
									<WebshopPriorityOrder mode="priority-order-checkout" />
								</div>
							</div>

							<WebshopLoyaltyNew mode="checkout" />

							<BaseWebshopCart v-slot="{parcels}">
								<div class="wc-col2-cnt-inner">
									
									<WebshopLoyaltyUse />

									<div class="checkout-coupons cart-coupons">
										<WebshopCouponForm mode="checkout" />
									</div>

									<div class="checkout-dropdown2 dropdown-cart">
										<div class="checkout-dropdown-btn checkout-dropdown-btn-cart">
											<BaseCmsLabel code="products_in_shopping_cart" class="checkout-dropdown-title" tag="span" />
											
											<span class="checkout-dropdown-button">
												<span class="checkout-dropdown-inactive btn-inactive"><BaseCmsLabel code="webshop_btn_order_details" /><span class="plus"></span></span>
												<span class="checkout-dropdown-active btn-active"><BaseCmsLabel code="webshop_btn_hide_order_details" /><span class="plus"></span></span>
											</span>
										</div>
										<div class="checkout-totals" v-if="parcels[0]?.items?.length">
											<div class="shoppingcart_items_small">
												<div class="checkout-cart-intro">
													<h2 class="w-cart-title"><BaseCmsLabel code="shopping_cart" /> <span class="counter">({{parcels[0].items.length}})</span></h2>
										
													<BaseUtilsAppUrls v-slot="{items: appUrls}">
														<NuxtLink :to="appUrls.webshop_shopping_cart" class="w-btn-change"><BaseCmsLabel code="change_cart" tag="span" /></NuxtLink>
													</BaseUtilsAppUrls>
												</div>
												<div class="w-table w-table-small">
													<WebshopCartItem v-for="item in parcels[0].items" mode="checkout" :data="item" :key="item.shopping_cart_code" />
												</div>
											</div>
											<WebshopTotal :simple="true" />
										</div>
									</div>
								</div>
							</BaseWebshopCart>
						</div>
					</div>
				</div>

				<div class="wc-footer">
					<div class="checkout-wrapper">
						<div class="wc-footer-cnt">
							<div class="wc-info">
								<BaseCmsCopyright class="copyright" label="copyright" />
							</div>
							<BaseCmsLabel code="footer_payment_cards" class="cards" tag="div" />

							<div class="signature"><BaseCmsSignature /></div>
						</div>
					</div>
				</div>
			</BaseWebshopCheckout>
			<template #fallback>
				<BaseThemeUiLoading />
			</template>
		</ClientOnly>
	</div>
</template>

<script setup>
	const activeCart = ref(false);
	const labels = useLabels();
	const {mobileBreakpoint} = inject('rwd');
</script>

<style lang="less" scoped>
	.wc-cols{
		background: white; position: relative; display: flex;
		@media (max-width: @m){display: block;}
	}
	.wc-col1,.wc-col2{
		width: 50%; display: flex; flex-flow: column; position: relative;
		@media (max-width: @m){width: 100%; flex-flow: unset; align-items: unset; justify-content: unset;}
	}
	.wc-col1{
		align-items: flex-end; border-right: 1px solid var(--borderColor); position: relative;
		@media (max-width: @m){border: unset;}
	}
	.wc-col1-cnt{
		margin: 40px 110px 100px 0; width: 500px;
		@media (max-width: @t){padding: 35px 30px 60px 50px; margin: 0; width: 100%;}
		@media (max-width: @tp){padding: 20px 15px 50px 15px;}
		@media (max-width: @m){padding-bottom: 0;}
	}

	.wc-col2{
		background: url(assets/images/bg-main.jpg) top left no-repeat; background-size: cover;
		@media (max-width: @m){background: unset; display: flex; flex-flow: column;}
	}
	.wc-col2-cnt{
		width: 500px; margin: 40px 0 100px 110px;
		@media (max-width: @t){width: 100%; padding: 35px 50px 60px 30px; margin: 0;}
		@media (max-width: @tp){padding: 20px 15px 50px 15px;}
		@media (max-width: @m){padding: 0;}
	}
	.wc-col2-cnt-inner{
		box-shadow: 0 30px 40px 0 rgba(85,41,122,0.28); border-radius: 2px; background: white; border-radius: 2px;
		@media (max-width: @m){box-shadow: unset; background: white;}
	}

	.checkout-coupons{
		padding: 30px 40px 40px;
		@media (max-width: @t){padding: 20px 30px 25px;}
		@media (max-width: @tp){padding: 20px 15px 25px;}
		@media (max-width: @m){padding: 20px 15px;}
	}
	.checkout-dropdown-button,.checkout-dropdown-btn{display: none;}
	:deep(.checkout-dropdown-title){
		font-size: 24px; line-height: 32px; font-weight: 300; padding-bottom: 8px;
		span{font-weight: bold;}
		@media (max-width: @t){font-size: 22px; line-height: 30px; padding-bottom: 6px;}
		@media (max-width: @tp){font-size: 18px; line-height: 26px; padding-bottom: 5px;}
	}

	.checkout-cart-intro{
		display: flex; align-items: flex-end; justify-content: space-between; padding-left: 40px; padding-right: 40px; padding-top: 0; padding-bottom: 15px;
		@media (max-width: @t){padding-left: 30px; padding-right: 30px; padding-bottom: 12px;}
		@media (max-width: @tp){padding-left: 15px; padding-right: 15px; padding-bottom: 12px;}
	}
	.w-cart-title{
		font-size: 30px; line-height: 38px; padding-top: 0; padding-bottom: 0;
		.counter{font-size: 20px; line-height: 30px; color: var(--primaryColor);}
		@media (max-width: @t){
			.counter{font-size: 16px; line-height: 26px;}
		}
		@media (max-width: @tp){
			font-size: 20px; line-height: 26px;
			.counter{font-size: 12px; line-height: 18px;}
		}
	}
	.w-btn-change{
		font-size: 16px; line-height: 22px; color: var(--primaryColor); margin-bottom: 2px; position: relative; .transition(color); text-decoration: underline; text-underline-offset: 3px; text-decoration-color: var(--primaryColor);
		@media (min-width: @h){
			&:hover{text-decoration: none;}
		}
		@media (max-width: @t){font-size: 14px; line-height: 20px;}
		@media (max-width: @tp){font-size: 12px; line-height: 18px; margin-bottom: 0;}
		@media (max-width: @m){text-underline-offset: 1px;}
	}
	.w-btn-change-mobile{display: none;}
	.w-table-small{background: white;}

	//FOOTER
	.wc-footer{
		border-top: 1px solid var(--borderColor); padding: 42px 0;
		.checkout-wrapper{width: 1220px; margin: 0 auto;}
		@media (max-width: @t){
			padding: 32px 0;
			.checkout-wrapper{margin: 0 50px; width: auto;}
		}
		@media (max-width: @tp){
			padding: 26px 0;
			.checkout-wrapper{margin: 0 15px; width: auto;}
		}
		@media (max-width: @m){border: unset; padding: 26px 15px;}
	}
	.wc-footer-cnt{
		display: flex; align-items: center; justify-content: space-between; position: relative;
		.copyright{color: var(--textColor); padding: 0; opacity: 1; font-size: 14px; line-height: 18px; display: block;}
		.signature{
			font-size: 14px; line-height: 20px;
			:deep(a){color: var(--textColor);
				@media(min-width: @h){
					&:hover{color: var(--primaryColor);}
				}
			}
		}
		.cards{
			margin-left: -80px;
			:deep(p){padding-bottom: 0; display: flex; line-height: 0;}
			:deep(img){display: block; width: auto; margin: 0 2px 0 0; height: auto; max-height: 23px;}
			@media (max-width: @t){
				margin-left: 0;
				:deep(img){margin: 0 3px 0 0; max-height: 21px;}
			}
			@media (max-width: @tp){
				:deep(img){margin: 0 2px 0 0; max-height: 17px;}
			}
		}
		@media (max-width: @tp){
			.copyright,.signature{font-size: 12px; line-height: 16px;}
		}
		@media (max-width: @m){
			flex-flow: column;
			.wc-info{order: 2; padding: 12px 0 8px;}
			.signature{order: 3;}
		}
	}
</style>
